export default require('theme/router').default
